<template>
	  <div>
			<div class="menu"  :style="justifyContent"  v-for='c of col' :key="c">
<!--	TODO:删除	 <div class="menu-item" v-for='(item, index) in navList' :key="i" v-if="isShow(item,index,c)"  @click="activityList({link:'ArticleCat', query:{category:item.cid},  params:{ name:item.name,isFromHome:true,url:item.url}})">-->
              <div class="menu-item" v-for='(item, index) in navList' :key="i" v-if="isShow(item,index,c)"  @click="activityList(item)">
							<img class="menu-item-icon" :src="item.photo" />
					</div>
			</div>
		</div>
</template>

<script>
import { mapState, mapGetters,mapActions } from 'vuex';
import { ENUM } from '../../../const/enum.js';

export default {
  name: "HomeMenu",
  computed: {
  	...mapState({
			isOnline: state => state.auth.isOnline,
			navList: state => state.home.navList,
			orderStatus: state => state.order.orderStatus,
		})
	},
	data(){
		return {
      col:[],
      justifyContent:{'justify-content':'center'}
    }
	},
	created(){
		if (this.navList && this.navList.length) {

    }else{
      this.fetchNavList({}).then(
        response => {
          var max = Math.ceil(this.navList.length/4)
          if(max>1){
            this.justifyContent = {'justify-content':'flex-start'}
          }else{
            this.justifyContent = {'justify-content':'center'}
          }
					for(var m=0;m<max;m++){
						this.col.push(m)
					}
				},
        error => {}
      )
    }
	},
  methods: {
		...mapActions({
      fetchNavList: 'fetchNavList',
		}),
		isShow:function(item,index,c) {
			return  Math.floor(index/4) == c  &&  item.ifshow =='1' 
  	},
    formatUrl: function(url) {
      let arrUrl = url.split("?");
      if (arrUrl.length>1) {
        arrUrl[0] = arrUrl[0].replace(".php","");
        arrUrl[0] = arrUrl[0].replace("_","");
        url = arrUrl.join("?");
      }
      return url;
    },
  	activityList: function(item) {
			//this.$router.push({ name: item.link, query:item.query });
/* TODO : 原传入的item，测试好后删除
item = {
  link:'ArticleCat', 
  query:{category:item.cid},  
  params:{ 
    name:item.name,
    isFromHome:true,url:item.url
  }
}
item = {
  cid: 7,
  ifshow: 1,
  name: "关于我们",
  photo: "https://sonymall.bestegou.com/data/categorylogo/1586787158443131100.png",
  //url: "article_cat.php?id=7"  
  url: "article_cat.php?id=7"  
}*/

      let url = item.url || ""
      if (url && url.indexOf("http")>-1) {
        window.location.href = url
      }else{
        //url = url.replace(".php","")
        console.log("url:",url)
        url = this.formatUrl(url);
        console.log("url after processed : ", url)
        this.$router.push(url);
      }

/* TODO ：测试好后删除
      let url =  item.params.url || ""
      if (url && url.indexOf("http")>-1) {
        window.location.href = url
      }else{
        this.$router.push({ name: item.link, query:item.query });
      }  */

  	},
  }
};
</script>

<style lang="scss" scoped>
.menu {
  width: 100%;
  display: flex;
  justify-content: row;
  padding: 16px 0;
  background: #FFFFFF;
  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 25%;
    .menu-item-icon {
      width: 54%;
      height: auto;
      overflow: hidden;
    }
    .menu-item-title {
      color: #333333;
      font-size: 12px;
      margin-top: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/child/HomeMenu.vue